import React, { useState, useRef } from "react";
import { AuthProvider } from "../../../context/AuthContext.js";
import "../dashboard.css";

export default function Anuncios() {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const fileInputRef = useRef(null);

    const onFileChange = (event) => {
        setSelectedFiles(event.target.files);
        setUploadSuccess(false); // reset success message
    };

    const onFileUpload = async () => {
        if (selectedFiles.length === 0) {
            alert("No files selected.");
            return;
        }

        for (let file of selectedFiles) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("fileName", file.name);
            formData.append("authCode", "crunchypancakes4791@");

            const response = await fetch(
                "https://iglesiaevangelicadelafe.com/api-church/imageUpload.php",
                {
                    method: "POST",
                    body: formData,
                    mode: "cors",
                }
            );

            const data = await response.json();
            if (!data.success) {
                alert("Hubo un error al subir el archivo.");
                return;
            }
        }

        // Si todo se subió bien:
        setUploadSuccess(true);
        setSelectedFiles([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // limpiar input
        }
    };

    return (
        <>
            <h1 className="dashboardTitle">Subir Anuncios</h1>
            <p className="dashboardSubtitle">Solo archivos PDF</p>

            <AuthProvider>
                <div className="uploadSection">
                    <input
                        ref={fileInputRef}
                        type="file"
                        onChange={onFileChange}
                        name="fileUpload"
                        accept="image/png,image/jpeg,image/heic,application/pdf"
                        multiple
                        className="fileInput"
                    />
                    <p className="fileCount">
                        {selectedFiles.length} archivo(s) seleccionado(s)
                    </p>

                    {selectedFiles.length > 0 && (
                        <div className="filePreviewList">
                            <h3 className="filePreviewTitle">Archivos Seleccionados</h3>
                            {Array.from(selectedFiles).map((file, index) => (
                                <div className="fileItem" key={index}>
                                    <div className="fileIcon">
                                        {file.type === "application/pdf" ? (
                                            <span className="pdfIcon">📄</span>
                                        ) : (
                                            <span className="imageIcon">🖼️</span>
                                        )}
                                    </div>
                                    <div>
                                        <p className="fileName">{file.name}</p>
                                        <p className="fileSize">
                                            {(file.size / 1024 / 1024).toFixed(2)} MB
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <button onClick={onFileUpload} className="uploadButton">
                        Subir
                    </button>

                    {/* Success Box */}
                    {uploadSuccess && (
                        <div className="successBox">
                            ✅ Archivos subidos correctamente
                        </div>
                    )}
                </div>
            </AuthProvider>
        </>
    );
}
